<template>
  <div class="btn">
    <div @click="$emit('zoomIn')" style="width: 28px; height: 28px; margin: 2px;" class="hoverable tag">
      <span style="font-size: 15pt;">+</span>
    </div>
    <div @click="$emit('zoomOut')" style="width: 28px; height: 28px; margin: 2px;" class="hoverable tag">
      <span style="font-size: 15pt;">-</span>
    </div>
    <div @click="$emit('zoomHome')" style="width: 28px; height: 28px; margin: 2px;" class="hoverable tag">
      <span style="font-size: 15pt;">&#x2922;</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Controls"
}
</script>

<style scoped>
.btn {
  height: 35px;
  box-shadow: 2px 2px 7px #777777;
  border-radius: 3px;
  background-color: #cccccc;
  font-weight: bold;
  font-size: 17pt;
  cursor: pointer;
}

.hoverable:hover {
  opacity: 0.7;
}

</style>